import React from "react";
import { parsal_img } from "../assets/mediaCall";
import { Link } from "react-router-dom";

const Footer = () => {
  // Services, Bike Taxi, Packers & Movers, Two Wheelers, Trucks, All India Parsal
  return (
    <footer className="bg-[#212226] pt-24 mlg:pt-16 pb-10">
      <div className="w-[85vw] mlg:w-[90vw] smp:w-[93vw] mx-auto">
        <div className="w-full flex gap-4 mlg:flex-col mlg:gap-10 sm:flex-row sm:justify-between sm:gap-3 mb-4">
          <div className="flex w-[35%] mlg:w-full mlg:gap-2 mlg:justify-between sm:w-1/2">
            <div className="flex flex-col gap-5 w-[100%] mlg:w-[40%] sm:w-full">
              <div>
                <img src={parsal_img.f_logo} alt="App Icon" />
              </div>

              <div className="mlg:hidden">
                <p className="text-[#D8D8D8] text-[14px] inter font-normal w-[60%] mlg:w-full">
                  Parsal is a tech-enabled logistics company offering a variety
                  of intracity and intercity delivery services.
                </p>
              </div>

              <div className="flex gap-2.5">
                <img
                  src={parsal_img.social1}
                  alt="App Icon"
                  className="w-[18px] h-[18px] object-contain"
                />
                <img
                  src={parsal_img.social2}
                  alt="App Icon"
                  className="w-5 h-5 object-contain"
                />
                <img
                  src={parsal_img.social3}
                  alt="App Icon"
                  className="w-5 h-5 object-contain"
                />
              </div>
            </div>
            <div className="hidden mlg:block mlg:w-[40%] mdg:w-[43%] sm:hidden">
              <p className="text-[#D8D8D8] text-[14px] inter font-normal w-[60%] mlg:w-full">
                Parsal is a tech-enabled logistics company offering a variety of
                intracity and intercity delivery services.
              </p>
            </div>
          </div>
          <div className="flex gap-4 justify-between w-[65%] mlg:w-[100%] sm:w-[50%]">
            {/* About Us */}
            <div className="mt-2 w-1/3 sm:ml-[10%] sm:w-full xs:ml-[20%]">
              <h3 className="text-[#FFFFFF] font-semibold text-[16px] inter">
                Company
              </h3>
              <ul className="text-[#B4B4B4] flex flex-col gap-2 mt-3 font-normal text-[16px] inter">
                <li>
                  <a href="#" className="hover:underline">
                    About Us
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:underline">
                    Career
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:underline">
                    Blogs
                  </a>
                </li>
              </ul>
            </div>
            {/* Pricing */}
            <div className="mt-2 w-1/3 sm:hidden">
              <h3 className="text-[#FFFFFF] font-semibold text-[16px] inter">
                Quick Links
              </h3>
              <ul className="text-[#B4B4B4] flex flex-col gap-2 mt-3 font-normal text-[16px] inter">
                <li>
                  <a href="#" className="hover:underline">
                    Services
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:underline">
                    Bike Taxi
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:underline">
                    Trucks
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:underline">
                    Two Wheelers
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:underline">
                    Packers & Movers
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:underline">
                    All India Parsal
                  </a>
                </li>
              </ul>
            </div>

            {/* Media */}
            <div className="mt-2 w-1/3 sm:hidden">
              <h3 className="text-[#FFFFFF] font-semibold text-[16px] inter">
                Support
              </h3>
              <ul className="text-[#B4B4B4] flex flex-col gap-2 mt-3 font-normal text-[16px] inter">
                <li>
                  <Link to="/" className="hover:underline">
                    Contact Us
                  </Link>
                </li>
                <li>
                  <Link to="/privacy-policy" className="hover:underline">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/terms-and-conditions" className="hover:underline">
                    Terms of Services
                  </Link>
                </li>
                <li>
                  <Link to="/insurance" className="hover:underline">
                    Insurance Policy
                  </Link>
                </li>
                <li>
                  <Link to="/tds-declaration" className="hover:underline">
                    TDS Declaration
                  </Link>
                </li>
                <li>
                  <Link to="/ride-guidelines" className="hover:underline">
                    Ride Guidelines
                  </Link>
                </li>
                <li>
                  <Link to="/load-unload" className="hover:underline">
                    Load Unload Charges
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Responsive Pricing & Media  */}
        <div className="hidden sm:flex justify-between gap-3">
          {/* Pricing */}
          <div className="mt-2 w-1/2">
            <h3 className="text-[#FFFFFF] font-semibold text-[16px] inter">
              Quick Links
            </h3>
            <ul className="text-[#B4B4B4] flex flex-col gap-2 mt-3 font-normal text-[16px] inter">
              <li>
                <a href="#" className="hover:underline">
                  Services
                </a>
              </li>
              <li>
                <a href="#" className="hover:underline">
                  Bike Taxi
                </a>
              </li>
              <li>
                <a href="#" className="hover:underline">
                  Packers & Movers
                </a>
              </li>
              <li>
                <a href="#" className="hover:underline">
                  Two Wheelers
                </a>
              </li>
              <li>
                <a href="#" className="hover:underline">
                  Trucks
                </a>
              </li>
              <li>
                <a href="#" className="hover:underline">
                  All India Parsal
                </a>
              </li>
            </ul>
          </div>

          {/* Media */}
          <div className="mt-2 w-1/2 ml-[10%] xs:ml-[20%]">
            <h3 className="text-[#FFFFFF] font-semibold text-[16px] inter">
              Support
            </h3>
            <ul className="text-[#B4B4B4] flex flex-col gap-2 mt-3 font-normal text-[16px] inter">
              <li>
                <Link to="/" className="hover:underline">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="hover:underline">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-and-conditions" className="hover:underline">
                  Terms of Services
                </Link>
              </li>
              <li>
                <Link to="/insurance" className="hover:underline">
                  Insurance Policy
                </Link>
              </li>
              <li>
                <Link to="/tds-declaration" className="hover:underline">
                  TDS Declaration
                </Link>
              </li>
              <li>
                <Link to="/ride-guidelines" className="hover:underline">
                  Ride Guidelines
                </Link>
              </li>
              <li>
                <Link to="/load-unload" className="hover:underline">
                  Load Unload Charges
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-[1px] border-[#646262] my-10 w-[90%] mx-auto"></div>

        <div>
          <p className="text-[#6F6F6F] font-normal text-[16px] inter text-center">
            Copyright © {new Date().getFullYear()} Parsal. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
